const apiKey = 'AIzaSyDa9hxnY_QSAa664FTdDaRErlgn3ydUZBw'

import colorPalette from './colorPalette'

const {
	COLOR_LANDSCAPE,
	COLOR_BORDERS,
	COLOR_WATER,
	COLOR_LINE,
	COLOR_POINT_FILL,
	COLOR_SELECTED_POINT
} = colorPalette

const COLORS = {
	BORDERS: COLOR_BORDERS,
	LANDSCAPE: COLOR_LANDSCAPE,
	LINE: COLOR_LINE,
	POINT: COLOR_SELECTED_POINT,
	POINT_FILL: COLOR_POINT_FILL,
	WATER: COLOR_WATER
}

const POINT_MARKER_ICON_CONFIG = {
	path: 'M8 2.1c1.1 ' +
		'0 2.2 0.5 3 1.3 0.8 0.9 1.3 1.9 1.3 3.1s-0.5 2.5-1.3 3.3l-3 3.1-3-3.1c-0.8-0.8-1.3-2-1.3-3.3 0-1.2 0.4-2.2 1.3-3.1 0.8-0.8 1.9-1.3 3-1.3z',
	strokeOpacity: 0,
	strokeWeight: 0,
	strokeColor: COLORS.POINT,
	fillColor: COLORS.POINT,
	fillOpacity: 1,
	scale: 2
}

const mapSettings = {
	clickableIcons: false,
	streetViewControl: false,
	panControlOptions: false,
	gestureHandling: 'cooperative',
	backgroundColor: '#b0c4d9',
	mapTypeControl: false,
	zoomControlOptions: {
		style: 'SMALL'
	},
	zoom: 6,
	minZoom: 1,
	maxZoom: 16,
	styles: [
		{
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#606060"
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "administrative.land_parcel",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "administrative.neighborhood",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "landscape.man_made",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "landscape.natural",
			"stylers": [
				{
					"color": "#f0f0f0"
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "poi",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "labels.text",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"stylers": [
				{
					"color": "#e9e9e9"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"stylers": [
				{
					"color": "#000000"
				},
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#bababa"
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "water",
			"stylers": [
				{
					"color": "#497cb2"
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "labels.text",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		}
	]
}

export { apiKey, mapSettings, POINT_MARKER_ICON_CONFIG }
